import { render, staticRenderFns } from "./MainCertIcon.vue?vue&type=template&id=5eac4e5c&scoped=true&"
import script from "./MainCertIcon.vue?vue&type=script&lang=js&"
export * from "./MainCertIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5eac4e5c",
  null
  ,true
)

export default component.exports